import { useSelector } from "react-redux";
import { RootState } from "../redux/store/store";

export const usePrimaryIcdCodes = (): string[] => {
  const primaryDiagnosisDetails = useSelector((state: RootState) => {
    const details =
      state.singleMedicalPaOrder.singleMedicalPaOrder
        ?.primary_diagnosis_details;

    if (Array.isArray(details)) return details;
    if (details && typeof details === "object") return [details];
    return [];
  });

  return Array.from(
    new Set(
      primaryDiagnosisDetails
        .filter((item) => item.icd_code !== null && item.icd_code !== undefined)
        .map((item) => item.icd_code as string),
    ),
  );
};
